export const SET_CHO_VAY_EDIT = "SET_CHO_VAY_EDIT";
export const SET_THUOCTINH_TAISAN_TM_CAM_DO = "SET_THUOCTINH_TAISAN_TM_CAM_DO";
export const SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO =
  "SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO";
export const SET_CONFIG_TM_CAM_DO = "SET_CONFIG_TM_CAM_DO";
export const SET_TAI_SAN_CAM_CO_TM_CAM_DO = "SET_TAI_SAN_CAM_CO_TM_CAM_DO";
export const GET_TAI_SAN_THEO_CHO_VAY_TMCD = "GET_TAI_SAN_THEO_CHO_VAY_TMCD";
export const GET_TAI_SAN_THUOC_TINH_TMCD = "GET_TAI_SAN_THUOC_TINH_TMCD";
export const SET_LIST_LOAI_TAI_SAN_TM_CAM_DO =
  "SET_LIST_LOAI_TAI_SAN_TM_CAM_DO";
export const GET_LOAI_TAI_SAN_TMCD = "GET_LOAI_TAI_SAN_TMCD";
export const SHOW_FORM_CAM_DO = "SHOW_FORM_CAM_DO";
export const GET_CONFIG_SYS_TMCD = "GET_CONFIG_SYS_TMCD";
export const SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN =
  "SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN";
export const GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN =
  "GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN";
export const POST_CAM_DO = "POST_CAM_DO";
export const POST_CAM_DO_SUCCESS = "POST_CAM_DO_SUCCESS";
export const POST_CAM_DO_FAILURE = "POST_CAM_DO_FAILURE";
export const CHECK_EDIT_CHO_VAY = "CHECK_EDIT_CHO_VAY";
export const CHECK_EDIT_CUSTOMER = "CHECK_EDIT_CUSTOMER";
export const SET_ENABLE_EDIT_CHO_VAY = "SET_ENABLE_EDIT_CHO_VAY";
export const SET_ENABLE_EDIT_CUSTOMER = "SET_ENABLE_EDIT_CUSTOMER";
